import { render } from "./AboutDonation.vue?vue&type=template&id=0b741a0e&scoped=true"
import script from "./AboutDonation.vue?vue&type=script&lang=js"
export * from "./AboutDonation.vue?vue&type=script&lang=js"

import "./AboutDonation.vue?vue&type=style&index=0&id=0b741a0e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Setrin\\dev\\NTS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b741a0e"]])

export default __exports__